import React, { useEffect } from "react";
import { TspFormField } from "../../../components/primitives";
import useTspJourneyVisitPicker from "../../../hooks/useTspJourneyVisitPicker";
import { formatDate } from "../../../utils/tspFormat";

// The journey / city-visit selects of the upload dialog. Mounted ONLY when the
// dialog is not already told everything (a fixed city needs none of this), so
// the hook — and its requests — never run needlessly:
//   - no fixed journey: the in-progress journeys are requested, then the chosen
//     journey's visits;
//   - a fixed journey (`fixedJourneyId`): only that journey's visits are requested.
// The choice is reported upward through `onSelect({ journeyId, visitId })`.
export default function JourneyVisitFields({ fixedJourneyId, onSelect, errors, disabled }) {
  const picker = useTspJourneyVisitPicker(fixedJourneyId ? String(fixedJourneyId) : undefined, { skipJourneys: Boolean(fixedJourneyId) });

  useEffect(() => {
    onSelect({ journeyId: picker.journeyId, visitId: picker.visitId });
  }, [picker.journeyId, picker.visitId, onSelect]);

  return (
    <>
      <div className="tsp-journey-form-grid">
        {!fixedJourneyId && (
          <TspFormField id="tsp-media-journeyId" label="Journey" required error={errors.journeyId}>
            <select
              id="tsp-media-journeyId"
              className="tsp-field-control"
              value={picker.journeyId}
              disabled={disabled}
              aria-invalid={errors.journeyId ? "true" : undefined}
              onChange={(event) => picker.setJourneyId(event.target.value)}
            >
              <option value="">Select journey</option>
              {(picker.journeys.data || []).map((journey) => (
                <option key={journey.id} value={journey.id}>
                  {journey.journey_name}
                </option>
              ))}
            </select>
          </TspFormField>
        )}

        <TspFormField id="tsp-media-cityVisitId" label="City visit" required error={errors.cityVisitId}>
          <select
            id="tsp-media-cityVisitId"
            className="tsp-field-control"
            value={picker.visitId}
            disabled={disabled || !picker.journeyId || picker.visits.loading}
            aria-invalid={errors.cityVisitId ? "true" : undefined}
            onChange={(event) => picker.setVisitId(event.target.value)}
          >
            <option value="">{picker.visits.loading ? "Loading…" : "Select city visit"}</option>
            {(picker.visits.data || []).map((visit) => (
              <option key={visit.id} value={visit.id}>
                {visit.location.label} — {formatDate(visit.visit_date)}
              </option>
            ))}
          </select>
        </TspFormField>
      </div>
      {!fixedJourneyId && picker.journeys.data && picker.journeys.data.length === 0 && <p className="tsp-muted-text">Media can be added once a journey is in progress.</p>}
    </>
  );
}
